export default __webpack_public_path__ + "static/Metropolis-Light-d4f54c3389a840147f08fec05c9f46c2.woff2";